module.exports = __webpack_public_path__ + "img/hr-tree-05-a-leaves.e49ff540.png";